export function getSpinView(isTurboSpin: boolean = true): any[] {
  return isTurboSpin
    ? [
        {
          type: 'CircleText',
          name: 'ui.spin_btn.bonus_game',
          text: 'BONUS GAME',
          visible: false,
          style: {
            fontSize: 30,
            fill: '#00FF11',
            wordWrapWidth: 1200,
            fontFamily: 'myriadpro-bold'
          },
          clockwise: false,
          radius: 120,
          layout: {
            mobile_portrait: {
              relativePosition: { x: 0.5, y: 1 },
              position: { x: 0, y: -325 }
            },
            mobile_landscape: {
              relativePosition: { x: 1, y: 0.5 },
              position: { x: -218, y: -43 }
            },
            default: {
              relativePosition: { x: 1, y: 0.5 },
              position: { x: -132, y: -43 }
            }
          }
        },
        {
          type: 'CircleText',
          name: 'ui.spin_btn.free_spins_game',
          text: 'FREE SPINS GAME',
          visible: false,
          style: {
            fontSize: 30,
            fill: '#00FF11',
            wordWrapWidth: 1200,
            fontFamily: 'myriadpro-bold'
          },
          clockwise: false,
          radius: 120,
          layout: {
            mobile_portrait: {
              relativePosition: { x: 0.5, y: 1 },
              position: { x: 0, y: -325 }
            },
            mobile_landscape: {
              relativePosition: { x: 1, y: 0.5 },
              position: { x: -218, y: -43 }
            },
            default: {
              relativePosition: { x: 1, y: 0.5 },
              position: { x: -132, y: -43 }
            }
          }
        },
        {
          type: 'Text',
          name: 'ui.spin_btn.free_rounds',
          text: 'FS',
          visible: false,
          relativePosition: {
            x: 1,
            y: 0.5
          },
          layout: {
            mobile_portrait: {
              position: { x: 0, y: -210 },
              relativePosition: { x: 0.5, y: 1 }
            },
            mobile_landscape: {
              position: { x: -206, y: 75 },
              relativePosition: { x: 1, y: 0.5 }
            },
            default: {
              position: { x: -130, y: 75 },
              relativePosition: { x: 1, y: 0.5 }
            }
          },
          style: {
            fontSize: 37,
            fill: '#00FF11',
            wordWrapWidth: 500,
            fontFamily: 'myriadpro-bold'
          }
        },
        {
          type: 'Text',
          name: 'ui.spin_btn.tournament_label',
          text: 'TR',
          visible: false,
          relativePosition: {
            x: 1,
            y: 0.5
          },
          layout: {
            mobile_portrait: {
              position: { x: 0, y: -210 },
              relativePosition: { x: 0.5, y: 1 }
            },
            mobile_landscape: {
              position: { x: -206, y: 75 },
              relativePosition: { x: 1, y: 0.5 }
            },
            default: {
              position: { x: -130, y: 75 },
              relativePosition: { x: 1, y: 0.5 }
            }
          },
          style: {
            fontSize: 37,
            fill: '#00FF11',
            wordWrapWidth: 500,
            fontFamily: 'myriadpro-bold'
          }
        }
      ]
    : [
        {
          type: 'CircleText',
          name: 'ui.spin_btn.bonus_game',
          text: 'BONUS GAME',
          visible: false,
          style: {
            fontSize: 30,
            fill: '#00FF11',
            wordWrapWidth: 1200,
            fontFamily: 'myriadpro-bold'
          },
          clockwise: false,
          radius: 120,
          layout: {
            mobile_portrait: {
              relativePosition: { x: 0.5, y: 1 },
              position: { x: 0, y: -335 }
            },
            mobile_landscape: {
              relativePosition: { x: 1, y: 0.5 },
              position: { x: -230, y: -43 }
            },
            default: {
              relativePosition: { x: 1, y: 0.5 },
              position: { x: -144, y: -43 }
            }
          }
        },
        {
          type: 'CircleText',
          name: 'ui.spin_btn.free_spins_game',
          text: 'FREE SPINS GAME',
          visible: false,
          style: {
            fontSize: 30,
            fill: '#00FF11',
            wordWrapWidth: 1200,
            fontFamily: 'myriadpro-bold'
          },
          clockwise: false,
          radius: 120,
          layout: {
            mobile_portrait: {
              relativePosition: { x: 0.5, y: 1 },
              position: { x: 0, y: -335 }
            },
            mobile_landscape: {
              relativePosition: { x: 1, y: 0.5 },
              position: { x: -230, y: -43 }
            },
            default: {
              relativePosition: { x: 1, y: 0.5 },
              position: { x: -144, y: -43 }
            }
          }
        },
        {
          type: 'Text',
          name: 'ui.spin_btn.free_rounds',
          text: 'FS',
          visible: false,
          relativePosition: {
            x: 1,
            y: 0.5
          },
          layout: {
            mobile_portrait: {
              position: { x: 0, y: -220 },
              relativePosition: { x: 0.5, y: 1 }
            },
            mobile_landscape: {
              position: { x: -216, y: 75 },
              relativePosition: { x: 1, y: 0.5 }
            },
            default: {
              position: { x: -140, y: 75 },
              relativePosition: { x: 1, y: 0.5 }
            }
          },
          style: {
            fontSize: 37,
            fill: '#00FF11',
            wordWrapWidth: 500,
            fontFamily: 'myriadpro-bold'
          }
        },
        {
          type: 'Text',
          name: 'ui.spin_btn.tournament_label',
          text: 'TR',
          visible: false,
          relativePosition: {
            x: 1,
            y: 0.5
          },
          layout: {
            mobile_portrait: {
              position: { x: 0, y: -220 },
              relativePosition: { x: 0.5, y: 1 }
            },
            mobile_landscape: {
              position: { x: -216, y: 75 },
              relativePosition: { x: 1, y: 0.5 }
            },
            default: {
              position: { x: -140, y: 75 },
              relativePosition: { x: 1, y: 0.5 }
            }
          },
          style: {
            fontSize: 37,
            fill: '#00FF11',
            wordWrapWidth: 500,
            fontFamily: 'myriadpro-bold'
          }
        }
      ];
}
